import im_shape_1 from 'assets/images/shape-home-1.png';
import im_shape_2 from 'assets/images/shape-home-2.png';
import im_shape_3 from 'assets/images/shape-home-3.png';
import PropTypes from 'prop-types';
import React from 'react';
import tw, { css } from 'twin.macro';

const panelStyles = css`
		${tw`flex items-center justify-center relative`};
		background-image: url(${im_shape_2});
		background-position: center top;
		background-repeat: no-repeat;
		background-size: contain;
		width: 25rem;
		height: 8rem;
`;

const firstPanelStyles = css`
		${panelStyles};
		${tw`pb-05`};
		background-image: url(${im_shape_1});
`;

const lastPanelStyles = css`
		${panelStyles};
		background-image: url(${im_shape_3});
		background-position: center top;
		background-repeat: no-repeat;
		background-size: contain;
		width: 25rem;
		height: 13rem;

		> svg {
			 ${tw`mt-20 top-0`};
		}
`;

const iconStyles = css`
	${tw`absolute left-0 ml-20 z-10 fill-current text-main`};
	margin-top: -0.7rem;
`;

export default function Panel({ firstPanel, lastPanel, Icon, title, subtitle, ...props }) {
	return (
		<div css={[
			firstPanel && firstPanelStyles,
			(!firstPanel && !lastPanel) && panelStyles,
			lastPanel && lastPanelStyles
		]} {...props}>
			<Icon css={iconStyles} width='2.4rem' height='2.4rem' />
			<div className='w-full flex flex-col items-center justify-center px-18 z-10'>
				<p className='mb-03'>{title}</p>
				<p className='text-center font-semibold'>{subtitle}</p>
			</div>
			<div/>
		</div>
	);
}

Panel.propTypes = {
	Icon: PropTypes.oneOfType([
		PropTypes.string.isRequired,
		PropTypes.func.isRequired
	]),
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired
};
